import React, { useState, useEffect } from 'react';
import { Input, InputNumber, Select } from 'antd';

import area from '../../data/Location';
import { util } from '../../utils/functions/custom';
import { defaultSettingEnum } from './AppEnums';


export const ContactField = ({ onContactChange, contactValue }) => {
  let [areaCodes, setAreaCodes] = useState([...area.areaCodes.sort(util.setDynamicSort("text"))]);
  const [selected, setSelected] = useState();
  const [value, setValue] = useState();
  const [defaultCode, setDefaultCode] = useState({ value: "+27", text: "+27 (ZA)" });
  const [numericValidation, setNumericValidation] = useState();

  const { Option } = Select;

  useEffect(() => {
    reorganizeList();
    preSelectAreaCode();
  }, [contactValue]);

  const preSelectAreaCode = () => {
    if (contactValue) {
      const fullContact = contactValue.split(" ");
      const _areaCode = areaCodes.find(
        (record) => record.value == fullContact[0]
      );

      if (_areaCode) {
        setSelected(_areaCode);
        setValue(fullContact[1]);
        onContactChange(contactValue);
      }
    } else {
      setValue("");
      setSelected("");
    }
  };

  const reorganizeList = () => {
    let sortedCountryCodes = areaCodes.filter((code) => code.value !== defaultSettingEnum.COUNTRY_CODE)
    let tmpSortedCountryCodes = [...sortedCountryCodes];
    tmpSortedCountryCodes.unshift(defaultCode);
    setAreaCodes(tmpSortedCountryCodes);
  }

  const onAreaCodeChange = (selected) => {
    const selectedAreaCode = areaCodes.find((item, index) => index == selected);
    setSelected(selectedAreaCode);

    //Update form contact even when only country code is selected
    if (value) {
      const fullcontact = `${selectedAreaCode.value} ${value}`;
      onContactChange(fullcontact);
    }
  }

  const onChange = (e) => {
    const { value } = e.target;
    if (selected && value) {
      const contactInput = util.toNumeric(value)

      const fullcontact = `${selected.value} ${contactInput}`;
      setValue(contactInput);
      onContactChange(fullcontact);
    }
    else if (selected && !value) {
      setValue(0);
    }
  }

  const onBlur = () => {
    if (value === 0) onContactChange(0);
  }

  const selectAreaCodes = (
    <Select style={{ width: 106 }} onChange={onAreaCodeChange} value={selected}>
      {areaCodes.map((code, index) => (<Option key={index}>{code.text}</Option>))}
    </Select>
  )

  return (
    <div>
      <Input
        addonBefore={selectAreaCodes}
        className="contact-number"
        maxLength={12}
        minLength={6}
        onChange={onChange}
        value={value}
        onBlur={onBlur}
      />
    </div>
  )
}

// export default ContactField;